// Centralized label mappings for consistent UI display across all apps

// Property type labels
export const PROPERTY_TYPE_LABELS = {
  detached_house: 'Omakotitalo',
  semi_detached: 'Paritalo',
  row_house: 'Rivitalo',
  apartment_building: 'Kerrostalo',
  commercial_property: 'Liikekiinteistö',
} as const

/** Fallback when an address is known but the property type is not. */
export const DEFAULT_PROPERTY_TYPE = 'detached_house' as const

// Customer type labels
// Mantine palette keys for the customer/opportunity organisation type — both
// enums share these values, so both sides badge them the same way.
export const CUSTOMER_TYPE_COLORS: Record<string, string> = {
  household: 'blue',
  housing_company: 'cyan',
  company: 'green',
  agency: 'grape',
}

export const CUSTOMER_TYPE_LABELS = {
  household: 'Kotitalous',
  housing_company: 'Taloyhtiö',
  company: 'Yritys',
  agency: 'Isännöintitoimisto',
} as const

// Returns true for both `company` and `housing_company`. Use this in business
// logic that should treat housing companies (asunto-osakeyhtiö) the same way
// as regular companies — e.g. company portal access, B2B billing templates,
// or visit feedback routing. Use a strict `=== 'company'` check only when you
// genuinely want to exclude housing companies.
export function isCompanyType(
  type: string | null | undefined,
): type is 'company' | 'housing_company' {
  return type === 'company' || type === 'housing_company'
}

// Customer status labels
export const CUSTOMER_STATUS_LABELS = {
  active: 'Aktiivinen',
  paused: 'Tauolla',
  churned: 'Lopettanut',
  prospect: 'Prospekti',
} as const

// User role labels
export const USER_ROLE_LABELS = {
  user: 'Asukas',
  employee: 'Työntekijä',
  officer: 'Toimihenkilö',
  service_manager: 'Palvelupäällikkö',
  management: 'Johtoryhmä',
  admin: 'Admin',
} as const

// Customer membership: access role (RBAC — every value here grants access)
export const ACCESS_ROLE_LABELS = {
  owner: 'Omistaja',
  member: 'Jäsen',
} as const

// Customer membership: relationship type (pure CRM label — never grants access
// on its own; describes who the person is to the customer)
export const RELATIONSHIP_TYPE_LABELS = {
  property_manager: 'Isännöitsijä',
  board_chair: 'Hallituksen pj',
  board: 'Hallituksen jäsen',
  other: 'Muu',
} as const
